// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".favorite-fade-enter-active,.favorite-fade-leave-active{transition:opacity 100ms ease-out}.favorite-fade-enter,.favorite-fade-leave-to{opacity:0}.favorite-tag{position:absolute;top:var(--space-4)}@media (max-width: 767px){.favorite-tag{top:8px}}@media (max-width: 969px){.favorite-tag{top:12px}}.favorite-tag-product{right:var(--space-2)}.favorite-tag-pla{top:11px;right:0px;border-radius:50%;width:25px;justify-content:center;padding:5px 4px 4px 5px}\n", ""]);
// Exports
exports.locals = {
	"extraSmallBreakpoint": "320px",
	"smallBreakpoint": "425px",
	"mobileBreakpoint": "768px",
	"tabletBreakpoint": "970px",
	"desktopBreakpoint": "1200px",
	"largeBreakpoint": "1400px",
	"extraLargeBreakpoint": "1600px"
};
module.exports = exports;
